"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_request_builder_1 = require("../../core/http-request-builder");
var FileSaver = require("file-saver");
var send_command_request_1 = require("../../shared/model/send-command-request");
var command_request_1 = require("../../shared/model/command-request");
var command_type_1 = require("../../shared/model/command-type");
var diagnosis_web_socket_service_1 = require("./diagnosis-web-socket.service");
var DiagnosisService = /** @class */ (function () {
    function DiagnosisService(_http, _diagnosisNotification) {
        this._http = _http;
        this._diagnosisNotification = _diagnosisNotification;
        this.DOWNLOAD_COORDINATES = DiagnosisService.DIAGNOSIS_END_POINT + "/report";
        this.REQUEST_COMMAND = DiagnosisService.DIAGNOSIS_END_POINT + "/requestCommand";
        this.REQUEST_ADMEASUREMENT = DiagnosisService.DIAGNOSIS_END_POINT + "/requestAdmeasurement";
        this.GET_LAST_HOUR_COORDINATES = DiagnosisService.DIAGNOSIS_END_POINT + "/getCoordinatesFromVehicleBetweenDates";
        this.GET_COORDINATES_BY_DIAGNOSIS_ID = DiagnosisService.DIAGNOSIS_END_POINT + "/getCoordinatesFromDiagnosis";
        this.GET_DIAGNOSIS_TYPE = DiagnosisService.DIAGNOSIS_END_POINT + "/diagnosis-type";
    }
    DiagnosisService.prototype.dowloadCoordinates = function (coordinates) {
        this._http.post(this.DOWNLOAD_COORDINATES, coordinates)
            .subscribe(function (csv) {
            FileSaver.saveAs(new Blob([csv._body], { type: 'text/csv' }), 'relatorio_coordenadas' + new Date().toDateString() + '.csv');
        });
    };
    DiagnosisService.prototype.disablePanic = function (vehicles, parameters, trixUserId) {
        return this.sendCommand(vehicles, parameters, trixUserId, command_type_1.CommandType.DISABLE_PANIC);
    };
    DiagnosisService.prototype.blockVehicle = function (vehicles, parameters, trixUserId) {
        return this.sendCommand(vehicles, parameters, trixUserId, command_type_1.CommandType.BLOCK_VEHICLE);
    };
    DiagnosisService.prototype.sendCommand = function (vehicles, parameters, trixUserId, type) {
        var trixUser = trixUserId || this._diagnosisNotification.getVehicle().trixUserId;
        var sendCommandRequest = this.createSendCommandRequest(vehicles, parameters, type);
        return this._http.post(this.REQUEST_COMMAND + "?trixUserId=" + trixUser, sendCommandRequest);
    };
    DiagnosisService.prototype.getLastHourCoordinates = function (vehicle) {
        var interval = this.createCoordinatesInterval();
        return this._http
            .get(this.GET_LAST_HOUR_COORDINATES + "/" + vehicle.id + "?trixUserId=" + vehicle.trixUserId + "&start=" + interval.start + "&end=" + interval.end);
    };
    DiagnosisService.prototype.getCoordinatesFromDiagnosis = function (id) {
        return this._http
            .get(this.GET_COORDINATES_BY_DIAGNOSIS_ID + "/" + id);
    };
    DiagnosisService.prototype.createAdmeasurement = function (accessoryRange) {
        var vehicle = this._diagnosisNotification.getVehicle();
        var trixUser = vehicle.trixUserId;
        accessoryRange.vehicle = vehicle;
        accessoryRange.vehicleType = vehicle.vehicleType;
        return this._http.post(this.REQUEST_ADMEASUREMENT + "?trixUserId=" + trixUser, accessoryRange);
    };
    DiagnosisService.prototype.getDiagnosisticsTypes = function () {
        return this._http.get(this.GET_DIAGNOSIS_TYPE);
    };
    DiagnosisService.prototype.createCoordinatesInterval = function () {
        var now = new Date().toISOString();
        var hourAgo = this.generateHourAgo();
        return {
            end: now,
            start: hourAgo
        };
    };
    DiagnosisService.prototype.generateHourAgo = function () {
        var hourAgo = new Date();
        hourAgo.setHours(hourAgo.getHours() - 1);
        return hourAgo.toISOString();
    };
    DiagnosisService.prototype.createCommandRequest = function (parameters, type) {
        var commandRequest = new command_request_1.CommandRequest();
        commandRequest.expirationDate = this.getTomorrow();
        commandRequest.maximumAttempts = 3;
        commandRequest.type = type;
        commandRequest.parameters = parameters;
        return commandRequest;
    };
    DiagnosisService.prototype.createSendCommandRequest = function (vehicles, parameters, type) {
        var sendCommandRequest = new send_command_request_1.SendCommandRequest();
        sendCommandRequest.commandRequest = this.createCommandRequest(parameters, type);
        sendCommandRequest.vehicles = vehicles || [this._diagnosisNotification.getVehicle().id];
        return sendCommandRequest;
    };
    DiagnosisService.prototype.getTomorrow = function () {
        var tomorrow = new Date();
        tomorrow.setDate(new Date().getDate() + 1);
        return tomorrow.toISOString();
    };
    DiagnosisService.ctorParameters = function () { return [{ type: http_request_builder_1.HttpRequestBuilder }, { type: diagnosis_web_socket_service_1.DiagnosisWebSocketService }]; };
    DiagnosisService.DIAGNOSIS_END_POINT = '/diagnosis';
    return DiagnosisService;
}());
exports.DiagnosisService = DiagnosisService;
//# sourceMappingURL=diagnosis.service.js.map


// WEBPACK FOOTER //
// diagnosis.service.js